import Layout from "../components/Layout";
import { AdminDocumentos } from "../components/DocumentosMensuales/AdminDocumentos";

const AdminDocumentosMensuales = () => (
    <>
        <Layout />
        <div className="bg-slate-100 min-h-screen w-full overflow-y-auto">
            <AdminDocumentos />
        </div>
    </>
);

export default AdminDocumentosMensuales;
